import constantStrings from './utils/constant-strings.en';

import config from '@src/configs/aspendental';

// Bugsnag
export const BUGSNAG_NOTIFY_URL = 'https://bugsnag-notify.aspendental.com';
export const BUGSNAG_SESSIONS_URL = 'https://bugsnag-sessions.aspendental.com';
export const BUGSNAG_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string;
export const GOOGLE_RESERVE_PARTNER_ID = 20002677;
export const FALLBACK_FACILITY_PHONE_NUMBER = '8002773633';

export enum TagTheme {
	AspenDental = 'aspendental',
	AzPetVet = 'azPetVet',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
}
const { formNodeStrings, formNodeStringsES } = constantStrings;
/**
 * @collection ORDERED_FORM_NODES
 *
 * This structure contains global data related to the specific form
 * sections available to a user.
 */
export const ORDERED_FORM_NODES = Object.freeze([
	{ sectionName: formNodeStrings.patientInfo, sectionNameES: formNodeStringsES.patientInfo, enabledByDefault: true },
	{ sectionName: formNodeStrings.dateTime, sectionNameES: formNodeStringsES.dateTime, enabledByDefault: true },
	{
		sectionName: formNodeStrings.additionalInfo,
		sectionNameES: formNodeStringsES.additionalInfo,
		enabledByDefault: true,
	},
	{
		sectionName: formNodeStrings.guarantorInfo,
		sectionNameES: formNodeStringsES.guarantorInfo,
		enabledByDefault: false,
	},
	{
		sectionName: formNodeStrings.apptReview,
		sectionNameES: formNodeStringsES.apptReview,
		enabledByDefault: true,
		headerTitle: 'Review & Confirm Appointment',
	},
	{
		sectionName: formNodeStrings.confirmation,
		sectionNameES: formNodeStringsES.confirmation,
		enabledByDefault: true,
	},
]);

export const MOTTO_FORM_NODES = Object.freeze([
	{ sectionName: formNodeStrings.dateTime, sectionNameES: formNodeStringsES.dateTime, enabledByDefault: true },
	{ sectionName: formNodeStrings.patientInfo, sectionNameES: formNodeStringsES.patientInfo, enabledByDefault: true },
	{
		sectionName: formNodeStrings.guarantorInfo,
		sectionNameES: formNodeStringsES.guarantorInfo,
		enabledByDefault: false,
	},
	{
		sectionName: formNodeStrings.apptReview,
		sectionNameES: formNodeStringsES.apptReview,
		enabledByDefault: true,
		headerTitle: 'Review & Confirm Appointment',
	},
	{
		sectionName: formNodeStrings.confirmation,
		sectionNameES: formNodeStringsES.confirmation,
		enabledByDefault: true,
	},
]);

export const APP_CONFIGURATIONS = Object.freeze({
	services: {
		prod: {
			EAPI_REST_URL: 'https://api.aspendental.com/api/web/',
			EAPI_GRAPHQL_URL: 'https://api.aspendental.com/websitegraphql/graphql/',
			GOOGLE_RESERVE_API: 'https://www.google.com/maps/conversion/collect',
			USER_EVENTS_URL: 'https://api.teamtag.com/v1/aspendental/dataplatform/userevents/',
			GOOGLE_MAP_API_KEY: config.services.prod.GOOGLE_MAP_API_KEY,
			EAPI_BASE_URL: 'https://api.aspendental.com/',
		},
		nonprod: {
			EAPI_REST_URL: 'https://apistg.aspendental.com/api/web/',
			EAPI_GRAPHQL_URL: 'https://apistg.aspendental.com/websitegraphql/graphql/',
			GOOGLE_RESERVE_API: 'https://www.google.com/maps/conversion/debug/collect',
			USER_EVENTS_URL: 'https://userevents.dataplatform.gke.us-central1.gcp.stage.aspendental.com/',
			GOOGLE_MAP_API_KEY: config.services.nonprod.GOOGLE_MAP_API_KEY,
			EAPI_BASE_URL: 'https://apistg.aspendental.com/',
		},
	},
});

export const GUARANTOR_RELATIONSHIPS = ['Parent/Guardian', 'Grandmother', 'Grandfather', 'Aunt', 'Uncle', 'Other'];

export const SITE_META_DESCRIPTIONS = {
	standard:
		"It's easy to schedule an appointment with Aspen Dental. In a few steps, you will be able to book an appointment for you or your loved ones.",
	motto: 'Aspen Dental dentists are committed to your short and long-term oral health needs. Schedule an appointment with a dentist near you.',
};

export enum DataLayerStepNames {
	timeSelection = 'date_time_selection',
	findLocation = 'find_a_location',
	additionalPatientInfo = 'additional_patient_information',
	patientInformation = 'patient_information',
	reasonForVisit = 'reason_for_visit',
	reasonSelect = 'reason_selected',
	review = 'review',
	confirmation = 'confirmation',
}

export enum AppointmentErrorMessages {
	onlineUnavailable = "Unfortunately, you can't currently schedule this kind of appointment online.",
	alreadyScheduled = 'It looks like you already have an account with us.',
	unspecifiedError = 'There has been an error.',
	statusCode503 = 'Our online scheduling experience is temporarily down for maintenance.',
}

export const MOBILE_STEPPER_ACTIVE = true;

export const CACHE_CONTROL_NO_CACHE = 'no-cache, no-store, must-revalidate';
